module.exports = __webpack_public_path__ + "static/media/symbiotic-building.7e4b5ed5.jpeg";